export default class detailIF4IF_LicenseInvoices {
    load(sAction, data) {
        // call immediately after detailView is load

        if (!sAction.dataGet(data.prefix + '/fields/id/value')) {
            data.value = {};
            data.value.id = sAction.dataGet(data.prefix + '/fields/if4if_licenses_if4if_licenseinvoices_1_name/def/id_value');
            data.value.name = sAction.dataGet(data.prefix + '/fields/if4if_licenses_if4if_licenseinvoices_1_name/value');
            this.loadLicenseData(sAction, data);
        }
    }
    update(sAction, data) {
        switch (data.field) {
            case 'if4if_licenses_if4if_licenseinvoices_1if4if_licenses_ida':
                this.loadLicenseData(sAction, data);
                break;
            case 'invoice_amount':
            case 'currency_id':
                const price = sAction.dataGet(data.prefix + '/fields/invoice_amount/value');
                const currency = sAction.dataGet(data.prefix + '/fields/currency_id/value');
                const rate = sAction.currencies[currency].conversion_rate;
                const priceUSD = price/rate;
                const product_value = sAction.dataGet(data.prefix + '/fields/value/value');

                sAction.dsClear();
                sAction.dsAdd('set', data.prefix + '/fields/amount_usd/value', priceUSD);
                sAction.dsAdd('set', data.prefix + '/changes/fields/amount_usd', priceUSD);

                sAction.dsAdd('set', data.prefix + '/fields/total/value', (parseFloat(priceUSD) || 0) + (parseFloat(product_value) || 0));
                sAction.dsAdd('set', data.prefix + '/changes/fields/total', (parseFloat(priceUSD) || 0) + (parseFloat(product_value) || 0));
                sAction.dsProcess();
                break;

            case 'value':
                const total_value = sAction.dataGet(data.prefix + '/fields/amount_usd/value');
                sAction.dsClear();
                sAction.dsAdd('set', data.prefix + '/fields/total/value', (parseFloat(data.value) || 0) + (parseFloat(total_value) || 0));
                sAction.dsAdd('set', data.prefix + '/changes/fields/total', (parseFloat(data.value) || 0) + (parseFloat(total_value) || 0));
                sAction.dsProcess();
                break;
        }
        // call immediately after detailView field is update
    }
    newSubRecord(sAction, data) {
        // call immediately before route sub record
    }
    beforeSave(sAction, data) {
        // call bfore Record is save

        return true;
    }
    updateDetailLine(sAction, data) {
        // Uprava radku detailu
    }

    loadLicenseData(sAction, data) {
        if (!data.value.id) {
            return;
        }

        const fields = {
            name: 'name',
            accounts_if4if_licenses_1accounts_ida: 'accounts_if4if_licenseinvoices_1accounts_ida',
            accounts_if4if_licenses_1_name: 'accounts_if4if_licenseinvoices_1_name',
            if4if_contracts_if4if_licenses_1if4if_contracts_ida: 'if4if_contracts_if4if_licenseinvoices_1if4if_contracts_ida',
            if4if_contracts_if4if_licenses_1_name: 'if4if_contracts_if4if_licenseinvoices_1_name',
            percent_increase_per_year: 'percent_increase_per_year',
            payment_type: 'payment_type',
            grids_code: 'grids_code',
        };

        const sendData = {
            module: 'IF4IF_Licenses',
            id: data.value.id,
            fields: Object.keys(fields),
            action: 'getBeanInfo',
        };

        sAction.load();
        sAction.rest.fetchData('customAction', 'POST', sendData).then((response) => {
            sAction.dsClear();
            for (const [key, value] of Object.entries(response)) {
                if (key === 'name') {
                    sAction.dsAdd('set', data.prefix + '/fields/' + fields[key] + '/value', `${value} – invoice`);
                    sAction.dsAdd('set', data.prefix + '/changes/fields/' + fields[key], `${value} – invoice`);
                    continue;
                }
                sAction.dsAdd('set', data.prefix + '/fields/' + fields[key] + '/value', value);
                sAction.dsAdd('set', data.prefix + '/changes/fields/' + fields[key], value);
            }

            sAction.dsProcess();
            sAction.unLoad();
        });
    }
}
